/** Display label for a quote (quote_name replaces internal ID in the UI). */
export function formatQuoteName(quote) {
  const name = (quote?.quote_name || '').trim();
  if (name) return name;
  const id = quote?.id;
  if (!id) return '—';
  return `Quote-${String(id).replace(/-/g, '').slice(0, 8)}`;
}

/** Suggested name when creating a quote for a company. */
export function suggestQuoteName(companyName) {
  const base = (companyName || '').trim() || 'Quote';
  const date = new Date().toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
  return `${base} - ${date}`;
}
